import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ILastNotifications } from '../interfaces/last-notifications';
import { INotificationSearchParam } from '../interfaces/notification-search-param';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  readonly rootUrl = environment.apiUrl + '/api/Notifies/';

  constructor(private http: HttpClient) {
  }

  // API

  public getLatestNotify(): Observable<ILastNotifications> {
    return this.http.get<ILastNotifications>(this.rootUrl + 'getlatest');
  }

  public getNotify(notifyId: Number): Observable<any> {
    return this.http.get(this.rootUrl + 'getNotify', {
      params: {
        notifyId: notifyId.toString()
      }
    });
  }

  public markAsRead(notifyId: Array<Number>): Observable<any> {
    return this.http.get(this.rootUrl + 'markAsRead', {
      params: {
        IdNotifies: notifyId.toString()
      }
    });
  }

  public markAsUnRead(notifyId: Array<Number>): Observable<any> {
    return this.http.get(this.rootUrl + 'markAsUnRead', {
      params: {
        IdNotifies: notifyId.toString()
      }
    });
  }

  public notifyList(searchParams: INotificationSearchParam): Observable<any> {
    return this.http.post(this.rootUrl + 'listNotifies', searchParams);
  }
}
